<template>
  <nuxt-link :class="[{ 'child-active': isChildPage }]" v-bind="props">
    <span class="selector" />
    <img v-if="!colorize" class="icon" :src="src" />
    <GraphicMask v-else class="icon" :src="src" />
    <span class="label">{{ label }}</span>
  </nuxt-link>
</template>
<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router';
import type { NuxtLinkProps } from '#app';

interface ButtonNavProps extends NuxtLinkProps {
  label: string;
  src: string;
  sections: string[];
  to?: string | RouteLocationRaw;
  colorize?: boolean;
}
const props = defineProps({
  label: null,
  src: null,
  sections: null,
  to: null,
  colorize: { type: Boolean, default: true }
});

const route = useRoute();

const isChildPage = computed(() => {
  return (
    props.sections.filter((section) => {
      if (section === '') {
        return route.path === '/';
      } else {
        return route.path.indexOf(`/${section}`) === 0;
      }
    }).length > 0
  );
});
</script>
<style lang="scss" scoped>
a {
  --color_background: var(--color_secondary);
  --color: var(--color_neutral_800);
  --border_radius: var(--stroke_radius_n);

  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0.3rem;
  overflow: hidden;
  transition: color 200ms $ease-out-quad 50ms;
  border-radius: var(--border_radius) var(--border_radius);
  color: var(--color);
  @include font('xs', 500, 'secondary');

  @include above('l') {
    @include font('n', 600, 'secondary');
  }

  /* Révision */

  &::before {
    @include above('l') {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transform: translateX(-101%);
      transition: transform 250ms $ease-in-quad;
      border-radius: var(--border_radius) var(--border_radius)
        var(--border_radius) var(--border_radius);
      background: var(--color_background);
    }
  }

  @include above('l') {
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    height: 4.5rem;
    color: var(--color);
  }

  .selector {
    --color_background: var(--color_neutral_0);

    display: none;
    z-index: 1;

    @include above('l') {
      display: block;
      width: 0.9rem;
      height: 100%;
      margin-right: 0.6rem;
      transform: scaleY(0);
      transform-origin: 0% 100%;
      transition: transform 300ms $ease-out-expo 200ms;
      background-color: var(--color_background);
    }
  }

  .icon {
    z-index: 1;

    --color: var(--color_secondary_light);
  }

  .label {
    z-index: 1;

    @include above('l') {
      padding-left: 2rem;
    }
  }

  &:hover,
  &.router-link-active,
  &.router-link-exact-active,
  &.child-active,
  &:focus {
    --color: var(--color_secondary);

    outline: none;
    .icon {
      --color: var(--color_secondary);
    }
    @include above('l') {
      --color: var(--color_neutral_25);

      &::before {
        transform: translateX(0);
        transition: transform 250ms $ease-out-quad;
      }
      .icon {
        --color: var(--color_neutral_25);
      }
    }
  }
}
</style>
